import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import FloatCart from "../FloatCart";
import OrderScreen from "../Order";
import Shelf from "../Shelf";

const App = () => {
	const match = useRouteMatch();

	return (
		<div className="App">
			<Switch>
				<Route exact path={`/Shop/`}>
					<main>
						<Shelf />
					</main>
					{false && <FloatCart />}
				</Route>

				<Route path={`/Shop/Order/:orderId`}>
					<OrderScreen />
				</Route>
			</Switch>
		</div>
	);
};

export default App;
